import PrImgIconComponent from './pr-img-icon';

export default PrImgIconComponent;
